import { render, staticRenderFns } from "./TransportFare.vue?vue&type=template&id=34fc18be&scoped=true&"
import script from "./TransportFare.vue?vue&type=script&lang=js&"
export * from "./TransportFare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc18be",
  null
  
)

export default component.exports